import { inventoriesApi } from '@/api/clients/inventoriesApi'
import { request, orgBase } from '@/api/http'
import type { ImportResult, BulkImportResult } from '@/api/types'

// Connectors are not first-class in qtz-risk — they are the inventory-scoped
// import seam over Module 1 (qtz-discovery). This client wraps that seam.
//
//   all       → CBOM crypto assets + inventory business-context (CMDB)
//   discovery → CBOM crypto assets only
//   cmdb      → inventory business-context only
//
// SBOM is not a separate pull: qtz-risk's parser keeps only crypto components,
// so software components are not modelled in P1 (covered conceptually by CBOM).
export const connectorsApi = {
  importAll(orgId: string, invId: string): Promise<ImportResult> {
    return inventoriesApi.import(orgId, invId, 'all')
  },
  importCbom(orgId: string, invId: string): Promise<ImportResult> {
    return inventoriesApi.import(orgId, invId, 'discovery')
  },
  importContext(orgId: string, invId: string): Promise<ImportResult> {
    return inventoriesApi.import(orgId, invId, 'cmdb')
  },
  // Full reconcile with qtz-discovery: add/update/remove mirrored inventories & sources.
  syncData(orgId: string): Promise<BulkImportResult> {
    return request(`${orgBase(orgId)}/inventories/import-all`, { method: 'POST' })
  },
}
